// getIsAnyModalOpened.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

/**
 * Select is any modal is opened
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {array} modalIds - modal ids.
 * @return {bool}
 */
const getIsAnyModalOpened = createCachedSelector(
  state => state.get('modals'),
  (state, modalIds) => modalIds,
  (state, modalIds, closeStatusList) => closeStatusList,
  (modals, modalIds = [], closeStatusList = []) => {
    return (
      modals.filter(
        modal =>
          modalIds.includes(modal.get('id')) &&
          !closeStatusList.includes(modal.get('status'))
      ).size > 0
    );
  }
)(
  (state, modalIds, closeStatusList) =>
    `getIsAnyModalOpened:${modalIds?.join(',')}:${closeStatusList}`
);

export default getIsAnyModalOpened;
